import { useQueryClient } from "@tanstack/react-query";
import { GridButton } from "@src/components/Buttons/GridButton";
import { createRow } from "@src/utility_functions/database_operations/rows/createRow";
import { ImportRowOptionsButtonsGrid } from "@src/components/Grids/ButtonGrids/ImportRowOptionsButtonsGrid";
import { CHART_TYPE_TIMELINE } from "#shared/constants/chartTypes.js";
import { useModal } from "@src/utility_functions/customHooks/useModal";

export const NewRowButtonsGrid = (props) => {
  const { openDialog, closeDialog, setModalContent } = useModal();
  const queryClient = useQueryClient();
  const newRowClickHandler = async () => {
    const newTimelineObject = {
      chartType: props.chartType,
      chartID: props.chartID,
    };
    const serverResponse = await createRow(newTimelineObject);
    if (serverResponse.error) {
      openDialog();
      setModalContent({
        modalTitle: serverResponse.errorDetails.title,
        errorModal: true,
        modalContent: (
          <div className="errorModalContainer">
            <p>{serverResponse.errorDetails.message}</p>
          </div>
        ),
      });
    } else if (serverResponse.payload.chartType === CHART_TYPE_TIMELINE) {
      queryClient.invalidateQueries({
        queryKey: ["timelineDocument", props.ownerID, props.chartID],
      });
      closeDialog();
    } else {
      window.location.href =
        "/user/" +
        props.loggedInUser?.id +
        "/" +
        props.chartType +
        "/" +
        serverResponse.payload.newRowID;
    }
  };

  return (
    <>
      <div className="dialog_grid_items_container">
        <GridButton
          text="Import Row"
          clickHandler={() => {
            setModalContent({
              modalTitle: "Import Row",
              modalContent: (
                <ImportRowOptionsButtonsGrid
                  loggedInUser={props.loggedInUser}
                  chartType={props.chartType}
                  chartID={props.chartID}
                  ownerID={props.ownerID}
                />
              ),
            });
          }}
        >
          <span className="fa-solid fa-code _font-size--2rem _margin-bottom--0p5rem"></span>
        </GridButton>
        <GridButton text="New Row" clickHandler={newRowClickHandler}>
          <span className="fa-regular fa-circle-plus _font-size--2rem _margin-bottom--0p5rem"></span>
        </GridButton>
      </div>
    </>
  );
};
